module.exports = __webpack_public_path__ + "static/clothing-bow-tie-9c3364c4c972d8a9d2fadde64a61798f.jpg";